import { render, staticRenderFns } from "./claimsFinanceManage.vue?vue&type=template&id=8064c1f6&scoped=true&"
import script from "./claimsFinanceManage.vue?vue&type=script&lang=js&"
export * from "./claimsFinanceManage.vue?vue&type=script&lang=js&"
import style0 from "./claimsFinanceManage.vue?vue&type=style&index=0&id=8064c1f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8064c1f6",
  null
  
)

export default component.exports